import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const labelVariants = cva(
	'leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
	{
		variants: {
			layout: {
				stacked: 'leading-3',
				horizontal: 'py-2',
				shortlabel: 'py-2',
				nolabel: 'hidden',
			},
		},
		defaultVariants: {
			layout: 'stacked',
		},
	},
)

const Label = React.forwardRef<
	React.ElementRef<typeof LabelPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
		VariantProps<typeof labelVariants>
>(({ className, layout, ...props }, ref) => (
	<LabelPrimitive.Root
		ref={ref}
		className={cn(labelVariants({ layout }), className)}
		{...props}
	/>
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
